import React from 'react';
import './styles.scss';
import {strings} from '../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import AppButton from '../../components/app-button';
import * as fonts from '../../util/fonts';
import {useHistory} from 'react-router-dom';
import RegisterHeader from '../../components/headers/register-header';
import FooterWaveLogin from '../../components/footer/footer-wave/FooterWaveLogin';
import colors from '../../util/colors';
import {put} from '../../api/api';
import {putUserPersonalDate} from '../../api/endpoints';
import {setShowPersonalDate} from '../../store/actions';

interface PersonalInfoConfirmationProps {
  labels: any;
  user: any;
  setShowPersonalDate: (value: boolean) => void;
}

function PersonalInfoConfirmation({
  labels,
  user,
  setShowPersonalDate,
}: PersonalInfoConfirmationProps) {
  const history = useHistory();
  const featureName = 'ProfileInfo-Confirmation';

  const onSubmitUpdatePersonalDate = async () => {
    try {
      await put(putUserPersonalDate(), {}, featureName);
    } catch (e: any) {
    } finally {
      setShowPersonalDate(false);
      history.push('/inicio');
    }
  };

  const pushHistoryProfile = () => {
    setShowPersonalDate(false);
    history.push({
      pathname: '/meu-perfil',
    });
  };

  return (
    <div className="personal-info-container">
      <RegisterHeader isDismiss={true} backHome={true} />
      <Column className="personal-info-confirmation-main-column">
        <Column className="personal-info-confirmation-container">
          <Row className="personal-info-confirmation-row">
            <Column className="reimbursement-history-titlecolumn">
              <Header1
                className="reimbursement-history-heading1 personal-info-confirmation-heading align-text"
                style={{...fonts.XL, ...fonts.SemiBold}}>
                {labels?.personal_information_confirmation_title}
              </Header1>
              <label className="align-text margin-top-1" style={{...fonts.ML}}>
                {labels?.personal_information_confirmation_subtitle}
              </label>
              <Column className="margin-top-3">
                <Column className="reimbursement-history-row margin-bottom-2">
                  <label style={{...fonts.SM}}>
                    {labels?.personal_information_confirmation_phone}
                  </label>
                  <label style={{...fonts.Medium, ...fonts.M}}>
                    {user.mobile && user.mobile !== '0'
                      ? user.mobile
                      : labels?.personal_information_confirmation_phone_missing}
                  </label>
                </Column>
                <Column className="reimbursement-history-row margin-bottom-5">
                  <label style={{...fonts.SM}}>
                    {labels?.personal_information_confirmation_email}
                  </label>
                  <label style={{...fonts.Medium, ...fonts.M}}>
                    {user.email}
                  </label>
                </Column>
              </Column>
            </Column>
          </Row>
          <div className="personal-info-confirmation-button-container">
            <div className="column-center">
              <AppButton onClick={onSubmitUpdatePersonalDate}>
                {labels?.personal_information_confirmation_button_confirm}
              </AppButton>
            </div>
            <div className="column-center margin-top-1">
              <AppButton
                variant="inverted"
                backgroundColor={'transparent'}
                onClick={pushHistoryProfile}>
                {labels?.personal_information_confirmation_button_update_data}
              </AppButton>
            </div>
          </div>
        </Column>
      </Column>
      <FooterWaveLogin
        color={colors.blue}
        backgroundColor={colors.lighterGrey}
      />
    </div>
  );
}

const mapStateToProps = ({stringsDefault, user}: any) => ({
  labels: stringsDefault.value.pt.personalInfoConfirmation,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setShowPersonalDate: (value: any) => dispatch(setShowPersonalDate(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PersonalInfoConfirmation)
);
